import { StateToken } from '@ngxs/store';
import {
  CurrentQuestion,
  LyaAutoInterviewCandidateMeta,
  LyaQuestion,
  ResponseSize,
} from './lya.types';

export interface LyaStateModel {
  conversationMeta: LyaAutoInterviewCandidateMeta | null;
  generatingQuestions: boolean;
  questionsForAsk: LyaQuestion[];
  respondedQuestions: LyaQuestion[];
  currentQuestion: CurrentQuestion | null;
  totalQuestions: number;
  endInterview: boolean;
  responsesSize: ResponseSize[];
  companyId: string | null;
  interviewKey: string | null;
  companyLogoUrl: string | null;
}
export const LYA_STATE_TOKEN = new StateToken<LyaStateModel>('lyaSpaceState');

export const INITIAL_LYA_STATE: LyaStateModel = {
  conversationMeta: null,
  generatingQuestions: false,
  questionsForAsk: [],
  respondedQuestions: [],
  currentQuestion: null,
  totalQuestions: 0,
  endInterview: false,
  responsesSize: [],
  companyId: null,
  interviewKey: null,
  companyLogoUrl: null,
};
